import { Browser } from '@capacitor/browser';
import type { INavigator, IWindow, NavigateParams } from 'oidc-client-ts';

class CapacitorWindow implements IWindow {
  async navigate(params: NavigateParams) {
    await Browser.open({ url: params.url });
    return { url: params.url };
  }
  async close() {
    await Browser.close();
  }
}

export class CapacitorNavigator implements INavigator {
  callback(_url: string, _params?: unknown) {
    return Promise.resolve();
  }
  async prepare(_params: unknown): Promise<IWindow> {
    return new CapacitorWindow();
  }
}
